import ListAdmin from "./data/list/ListAdmin";

export default function SettingsRoles() {
  return (
    <>
      <ListAdmin />
    </>
  );
}
